/**
 * Copyright (c) HashiCorp, Inc.
 */

import type { TOC } from '@ember/component/template-only';

export interface ListItemActionGenericSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLLIElement;
}

const ListItemActionGeneric: TOC<ListItemActionGenericSignature> = <template>
  {{! template-lint-disable no-yield-only }}
  {{yield}}
</template>;

export default ListItemActionGeneric;
